import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { Footer } from "../../layout/footer";
import { options, selector, can } from "../../api";
import { Loading } from "../constant";
import { buildingCRUD } from "../../actions/building";
import { EditBuilding } from "./edit";
import { AddBuilding } from "./modal";
import { UploadBuilding } from "./upload";
import { ScopeFilter } from "./ScopeFilter";

export const BuildingContent = () => {
  const user = selector.User();
  let location = useLocation();

  const [category] = useState(location.state && location.state.category);

  window.history.replaceState({}, document.title);

  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [dataId, setDataId] = useState(null);
  // Location filter (from ScopeFilter cascade).
  const [boundaryFilter, setBoundaryFilter] = useState(null);
  const [zoneFilter, setZoneFilter] = useState(null);

  useEffect(() => {
    // Debounce so typing in search doesn't fire a request per keystroke.
    const t = setTimeout(() => {
      if (category === null || category === undefined) {
        buildingCRUD
          .loadBuilding(postsPerPage, nextPage, value, boundaryFilter, zoneFilter)
          .then((resp) => {
            setCount(resp.data.count);
            setData(resp.data.results);
            setPageCount(Math.ceil(resp.data.count / postsPerPage));
          })
          .finally(() => {});
      } else {
        buildingCRUD
          .loadBuildingDashboard(postsPerPage, nextPage, category, value)
          .then((resp) => {
            setCount(resp.data.count);
            setData(resp.data.results);
            setPageCount(Math.ceil(resp.data.count / postsPerPage));
          })
          .finally(() => {});
      }
    }, 400);
    return () => clearTimeout(t);
  }, [page, postsPerPage, value, index, boundaryFilter, zoneFilter]);

  // Re-run from page 1 whenever the location filter changes.
  const handleScopeChange = (boundary, zone) => {
    setData([]);
    setPage(0);
    setNextPage(0);
    setBoundaryFilter(boundary);
    setZoneFilter(zone);
  };

  const handleChangePage = (event) => {
    setData([]);
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = (selectedOption) => {
    const sel = selectedOption.value;
    setData([]);
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0);
  };

  const handleSearch = (event) => {
    setData([]);
    setValue(event.target.value);
  };

  const handleChangeId = (e) => {
    setDataId(e);
  };

  return (
    <>
      <AddBuilding index={index} setIndex={setIndex} />
      <UploadBuilding index={index} setIndex={setIndex} />
      <EditBuilding dataId={dataId} index={index} setIndex={setIndex} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Building</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="#">Building</a>
                      </li>
                      <li className="breadcrumb-item active">List</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              value={value}
                              onChange={handleSearch}
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6"></div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          {/* New Building - visible to anyone who can add data, plus Locality leaders */}
                          {(can(user, 'add_data') || user?.admin_access === 'Shehia') && (
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-soft-primary"
                                data-bs-toggle="modal"
                                data-bs-target=".bs-example-modal-lg"
                              >
                                <i className="bi bi-plus-circle bi-lg"></i> &nbsp;
                                New Building
                              </button>
                            </div>
                          )}
                          {/* Upload Building - visible only for Admin users */}
                          {user?.is_staff && (
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-soft-info"
                                data-bs-toggle="modal"
                                data-bs-target=".uploadModal"
                              >
                                <i className="bi bi-upload bi-lg"></i> &nbsp;
                                Upload Building
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <ScopeFilter onChange={handleScopeChange} />
                    <table
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th data-ordering="true">SR No.</th>
                          <th data-ordering="true">Building Name</th>
                          <th data-ordering="true">Address Code</th>
                          <th data-ordering="true">Postcode</th>
                          <th data-ordering="true">Shehia Number</th>
                          <th data-ordering="true">Has Polygon</th>
                          <th className="d-flex justify-content-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((dt, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{dt.name ? dt.name : "N/A"}</td>
                            <td>{dt.address_code ? dt.address_code : "N/A"}</td>
                            <td>{dt.postcode ? dt.postcode : "N/A"}</td>
                            <td>{dt.house_no ? dt.house_no : "N/A"}</td>
                            <td>
                              {dt.has_polygon ? (
                                <span className="badge bg-success">Yes</span>
                              ) : (
                                <span className="badge bg-secondary">No</span>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="dropdown d-inline-block">
                                <button
                                  className="btn btn-soft-secondary btn-sm dropdown"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-fill align-middle"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <Link
                                      to={"/buildingkaya"}
                                      state={{ id: dt.id }}
                                      className="dropdown-item"
                                    >
                                      <i className="ri-home-4-line align-bottom me-2 text-muted"></i>{" "}
                                      Households &amp; Members
                                    </Link>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleChangeId(dt.id);
                                      }}
                                      data-bs-toggle="modal"
                                      data-bs-target=".editModal"
                                      className="dropdown-item edit-item-btn"
                                    >
                                      <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                                      Edit
                                    </a>
                                  </li>
                                  <li>
                                    <Link
                                      to={"/map"}
                                      state={{ type: "building", id: dt.id }}
                                      className="dropdown-item"
                                    >
                                      <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>{" "}
                                      View on map
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={"/map"}
                                      state={{ type: "building", id: dt.id, draw: true }}
                                      className="dropdown-item"
                                    >
                                      <i className="ri-pencil-ruler-2-line align-bottom me-2 text-muted"></i>{" "}
                                      Draw outline
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="row">{!data.length && <Loading />}</div>
                    <div className="row">
                      <div className="col-md-2">
                        <p>
                          <span>Showing </span>
                          <span>{data.length}</span> of <span>{count}</span>{" "}
                          entries
                        </p>
                      </div>
                      <div className="col-md-5"></div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select
                              options={options}
                              defaultValue={options[1]}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-auto paginate">
                            <ReactPaginate
                              previousLabel={
                                <i className="las la-angle-double-left la-lg"></i>
                              }
                              nextLabel={
                                <i className="las la-angle-double-right la-lg"></i>
                              }
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
